import React from 'react';
import { NavigatorContext } from '../context';

export function useNavigator() {
  return React.useContext(NavigatorContext);
}
